const engineTypeToLabel = {
  petrol: 'Бензин',
  diesel: 'Дизель',
  hybrid: 'Гібрид',
  electric: 'Електро',
};

export const getEngineTypeLabel = (engineType) => engineTypeToLabel[engineType];